import { Alert, AlertColor, Fade } from '@mui/material';
import { Modal } from '../modal';
import { FC } from 'react';

interface IAlertModal {
  message: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  severity: AlertColor;
  title?: string;
}

export const AlertModal: FC<IAlertModal> = ({
  message = 'Alert',
  open,
  setOpen,
  severity = 'error',
  title = 'Alert'
}) => {
  return (
    <Modal
      maxWidth="sm"
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      title={title}
    >
      <Fade in={open}>
        <Alert severity={severity}>{message}</Alert>
      </Fade>
    </Modal>
  );
};
